import React from 'react';
import { Modal } from 'react-bootstrap';
import './index.scss';
import { LoadingSpinnerDotted } from '../loading-spinner/Loader';

export default function ConfirmModal({ messageTxt, isLoading, showConfirmModal, setShowConfirmModal, confirmFnc }) {
    return (
        <Modal
            show={showConfirmModal}
            onHide={() => setShowConfirmModal(false)}
            keyboard={false}
            size="sm"
            centered
            className="confirm-modal-style"
        >
            <Modal.Body className='text-center'>
                <p>{messageTxt}</p>
                <div className='mt-3'>
                    <button className='btn btn-secondary-color btn-border-color' onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </button>
                    <button className='btn btn-primary-color btn-border-color ms-3' disabled={isLoading} onClick={() => confirmFnc()}>
                        {isLoading ? <LoadingSpinnerDotted /> : "Confirm"}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}